import { Injectable } from "@angular/core";

@Injectable()
export class Environment {
  public getEnvironmentVariable(value) {
    let data = {};
    let environment = this.getCurrentEnvironment();
    switch (environment) {
      case "localhost":
        data = {
          usersServiceEndPoint: "http://localhost:3000/usersServiceEndPoint",
          tokenGeneratorEndPoint:
            "http://localhost:3000/tokenGeneratorEndPoint",
          accountPreferencesEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_dev",
          accountPrefEmailEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_stg/v1/accountspreferences/sendemail",
          // accountPrefEmailEndpoint:
          //   'http://localhost:8080/v1/accountspreference',
          tokenApiKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          usersAPIKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          accountPrefsAPIKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          oe_url: "https://orderexpresspmodstg.cardinalhealth.com",
        };
        break;
      case "nextgendev.cardinalhealth.com":
        data = {
          usersServiceEndPoint:
            "https://dzrsa753r1.execute-api.us-east-1.amazonaws.com/oe_dev2",
          tokenGeneratorEndPoint:
            "https://iri1lvu09j.execute-api.us-east-1.amazonaws.com/oe_dev2",
          accountPreferencesEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_dev",
          // accountPreferencesEndpoint:
          // "https://accounts-preferences-nextgen-dev.apps.cf.np.gc.cahcloud.net",
          accountPrefEmailEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_dev/v1/accountspreferences/sendemail",
          // accountPrefEmailEndpoint: 'https://accounts-preferences-nextgen-dev.apps.cf.np.gc.cahcloud.net',
          tokenApiKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          usersAPIKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          accountPrefsAPIKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          oe_url: "https://orderexpresspmoddev.cardinalhealth.com",
        };
        break;

      case "nextgenstg.cardinalhealth.com":
        data = {
          usersServiceEndPoint:
            "https://dzrsa753r1.execute-api.us-east-1.amazonaws.com/oe_pmodstg",
          tokenGeneratorEndPoint:
            "https://iri1lvu09j.execute-api.us-east-1.amazonaws.com/oe_pmodstg",
          accountPreferencesEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_stg",
          // accountPreferencesEndpoint:
          // "https://accounts-preferences-nextgen-stg.apps.cf.np.gc.cahcloud.net",
          accountPrefEmailEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_stg/v1/accountspreferences/sendemail",
          tokenApiKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          usersAPIKey: "TOJ95ZnTTK5AImAo2Af8w7jtaUSyXhhleXuff3se",
          accountPrefsAPIKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          oe_url: "https://orderexpresspmodstg.cardinalhealth.com",
        };
        break;

      case "nextgen.cardinalhealth.com":
        data = {
          usersServiceEndPoint:
            "https://dzrsa753r1.execute-api.us-east-1.amazonaws.com/oe_prod",
          tokenGeneratorEndPoint:
            "https://iri1lvu09j.execute-api.us-east-1.amazonaws.com/oe_prod",
          accountPreferencesEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_prd",
          accountPrefEmailEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_prd/v1/accountspreferences/sendemail",
          tokenApiKey: "CR7DFGpjXd9GZ5G5o5rmU1IYeOKfnYo05fWNIZqx",
          usersAPIKey: "CR7DFGpjXd9GZ5G5o5rmU1IYeOKfnYo05fWNIZqx",
          accountPrefsAPIKey: "CR7DFGpjXd9GZ5G5o5rmU1IYeOKfnYo05fWNIZqx",
          oe_url: "https://orderexpress.cardinalhealth.com",
        };
        break;

      default:
        data = {
          usersServiceEndPoint:
            "https://dzrsa753r1.execute-api.us-east-1.amazonaws.com/oe_dev2",
          tokenGeneratorEndPoint:
            "https://iri1lvu09j.execute-api.us-east-1.amazonaws.com/oe_dev2",
          accountPreferencesEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_dev",
          accountPrefEmailEndpoint:
            "https://mqis2bj5nj.execute-api.us-east-1.amazonaws.com/nextgen_dev/v1/accountspreferences/sendemail",
          tokenApiKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          usersAPIKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          accountPrefsAPIKey: "7zX2ClDRyo62roUGDFVy36DttcvC1vS36mmk7DUk",
          oe_url: "https://orderexpresspmoddev.cardinalhealth.com",
        };
        break;
    }
    return data[value];
  }

  getCurrentEnvironment(): string {
    return window.location.hostname;
  }
}
